<template>
  <f7-page
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="cargar"
  >
    <f7-navbar>
      <f7-nav-left back-link="Atrás" sliding></f7-nav-left>
      <f7-nav-title>{{ tipo }} {{ busqueda }}</f7-nav-title>
    </f7-navbar>
    <f7-list
      media-list
      style="
        margin: 0px;
        height: 100%;
        overflow: auto;
        margin-bottom: 30px !important;
      "
    >
      <f7-list-item
        v-for="(anime, index) in animes"
        :link="'/anime/' + anime.id"
        :key="index"
        :text="anime.Sinopsis"
        :title="anime.Titulo"
        :subtitle="anime.Tipo"
      >
        <img slot="media" :src="anime.Imagen" width="80" />
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
export default {
  props: ["tipo", "busqueda"],
  data() {
    return {
      animes: [],
      pagina: 0,
      allowInfinite: true,
      showPreloader: true,
    };
  },
  methods: {
    cargar() {
      const self = this;
      this.pagina++;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;
      self.$f7.preloader.show();
      this.$f7.request.json(
        "https://www.jkanimeapp.com/ios/api.php?action=getAnimes&busqueda=" +
          this.busqueda +
          "&tipo=" +
          this.tipo +
          "&page=" +
          this.pagina,
        function (data) {
          let newItems = data.response;
          for (let i = 0; i < newItems.length; i += 1) {
            self.animes.push(newItems[i]);
          }
          self.showPreloader = false;
          self.allowInfinite = true;
          self.$f7.preloader.hide();
        }
      );
    },
  },
  mounted() {
    let self = this;
    this.$f7ready((f7) => {
      self.cargar();
    });
  },
};
</script>
